export default __webpack_public_path__ + "static/media/nft-dashboard.b51fae41.svg";